<!-- Container-fluid starts-->
<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title col-12 text-center"><b>Reset Password Using E-Mail</b></h4>
    </div>
    <div class="modal-body">
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <h5 class="text-center mt-3">Are you sure want to reset password for {{resetPassword.first_name}}</h5>
                </div>
            </div>
        </div>

    </div>
    <div class="modal-footer">
        <button type="button" class="btn cancel" (click)="close()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="change(1)">Confirm</button>
    </div>
</ng-template>
<ng-template #contentnow let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title col-12 text-center"><b>Reset Password Now</b></h4>
    </div>
    <div class="modal-body">
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <form [formGroup]="adminPassword">
                <div class="row form-group auth-form">
                    <input required="" readonly class="form-control" type="text" placeholder="Email" formControlName="email">
                        <em class="error" *ngIf="!adminPassword.get('email').valid && (adminPassword.get('email').dirty || adminPassword.get('email').touched)">Email is required</em>
                </div>
                <div class="row form-group auth-form">
                    <div class="input-group">
                        <input required="" type="text" formControlName="password"
                           class="form-control" placeholder="Password" aria-label="Recipient's username" aria-describedby="basic-addon1" [type]="conps ? 'password' : 'text'">
                                <div class="input-group-append">
                                     <span class="input-group-text" id="basic-addon3">
                                            <i [class]="conps ? 'fa fa-eye-slash' : 'fa fa-eye'" style="color: #7F3486" aria-hidden="true" (click)="conps = !conps"></i>
                                     </span>
                                </div>
                    </div>
                    <em class="error" *ngIf="adminPassword.get('password').hasError('required') && (adminPassword.get('password').dirty || adminPassword.get('password').touched)">Password is required</em>
                    <em *ngIf="adminPassword.get('password').hasError('minlength')" class="error help-block">Minimum 5 characters required</em>
                </div>
                <div class="row form-group auth-form">
                    <div class="input-group">
                        <input required="" type="text" formControlName="confirmpassword"
                               class="form-control" placeholder="Confirm Password" aria-label="Recipient's username" aria-describedby="basic-addon1" [type]="conps1 ? 'password' : 'text'">
                        <div class="input-group-append">
                           <span class="input-group-text" id="basic-addon2">
                               <i [class]="conps1 ? 'fa fa-eye-slash' : 'fa fa-eye'" style="color: #7F3486" aria-hidden="true" (click)="conps1 = !conps1"></i>
                           </span>
                        </div>
                    </div>
                    <em class="error" *ngIf="adminPassword.get('confirmpassword').hasError('required') && (adminPassword.get('confirmpassword').dirty || adminPassword.get('confirmpassword').touched)">Confirm Password is required</em>
                    <div *ngIf="checkPasswords()">
                        <em class="error help-block">
                            Enter same password as above
                        </em>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn cancel" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="change(2)">Confirm</button>
    </div>
</ng-template>

<ng-template #viewdetails let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title col-11 text-center" id="modal-basic-title"><b>Admin details</b></h4>
<!--        <div class="row">-->
<!--        <app-feather-icons  [icon]="'edit'" style="cursor: pointer;float: right;" (click)="editAction(rows)"></app-feather-icons>-->
        <i class="fa fa-close fa-lg mt-1" aria-hidden="true" style="color:#7F3486; cursor: pointer; float: right;" (click)="close()"></i>
    </div>
<!--    </div>-->
    <div class="modal-body">
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card-body pt-2">
                        <div class="row d-flex flex-column">
                            <div class="mb-5 fit-image">
                                <img *ngIf="viewdetail.profile_url != ''"
                                     [src]="sanitizer.bypassSecurityTrustResourceUrl(webhost + '/' + viewdetail.profile_url)" alt="">
                                <img *ngIf="viewdetail.profile_url == '' && viewdetail.gender.toLowerCase().trim() == 'male'"
                                     src="assets/images/ristaschool/male.png" alt="">
                                <img *ngIf="viewdetail.profile_url == '' && viewdetail.gender.toLowerCase().trim() == 'female'"
                                     src="assets/images/ristaschool/female1.png" alt="">
                                <img *ngIf="viewdetail.profile_url == '' && viewdetail.gender.toLowerCase().trim() == 'n/a'"
                                     src="assets/images/ristaschool/Do not want to disclose.png" alt="">
                                <img *ngIf="viewdetail.profile_url == '' && viewdetail.gender == ''"
                                     src="assets/images/ristaschool/Do not want to disclose.png" alt="">
                            </div>
                            <table>
                                <tr>
                                    <td class="pl-4 capital" ><b>First Name:</b></td>
                                    <td>{{viewdetail.first_name}}</td>
                                </tr>
                                <tr>
                                    <td class="pl-4 capital"><b>Last Name:</b></td>
                                    <td>{{viewdetail.last_name}}</td>
                                </tr>
                                <tr>
                                    <td class="pl-4"><b>E-mail id:</b></td>
                                    <td>{{viewdetail.email_id}}</td>
                                </tr>
                                <tr>
                                    <td class="pl-4 capital"><b>Contact Number:</b></td>
                                    <td>{{viewdetail.mobile}}</td>
                                </tr>
                                <tr>
                                    <td class="pl-4 capital"><b>Institution Name:</b></td>
                                    <td>{{viewdetail.school_name}}</td>
                                </tr>
                                <tr>
                                    <td class="pl-4"><b>Status:</b></td>
                                    <td class="badge badge-success" *ngIf="viewdetail.status == 'Active'">Active</td>
                                    <span class="badge  badge-danger" *ngIf="viewdetail.status == 'Inactive'">In-Active</span>
                                    <span class="badge badge-warning" *ngIf="viewdetail.status  == 'Suspended'">Suspended</span>
                                    <span class="badge badge-danger" *ngIf="viewdetail.status  == 'Deleted'">In-Active</span>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn cancel" (click)="close()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="editAction(rows)">Edit</button>
    </div>
</ng-template>

<div class="container-fluid px-0" *ngIf="schoolStatus?.length != 0">
    <div class="card pt-1">
        <div class="card-header">
            <h5>Admin Details</h5>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <div class="btn-popup pull-right">
                        <a class="btn btn-primary" [routerLink]="'/admin/create-admin/add'">Add Admin</a>
                </div>
            </div>
            </div>
            <div id="batchDelete" class="category-table custom-datatable transcation-datatable user-image">
                <div class="table-responsive">
                    <app-table [TableType]="'Admin'" [TableArray]="listData" (clickValue)="emittedValue($event)"></app-table>
                </div>
            </div>
    </div>
</div>
</div>
<div *ngIf="schoolStatus?.length == 0">
    <app-emptyschool>
    </app-emptyschool>
</div>
<!-- Container-fluid Ends-->
